/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardBody,
  Row,
  Container,
  CardImg,
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function PenjualanProduk() {

  return (
    <>
      <SimpleHeader name="Penjualan Produk" parentName="Report" />
      
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
                <CardBody>
                    <Row>
                        <div className="card-columns">
                            <Card>
                                <Link to="/admin/penjualan/so/penjualan/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/admin-cabang.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                            <Card>
                                <Link to="/admin/penjualan/so/penjualan/admin/pusat">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/admin-pusat.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                            <Card>
                                <Link to="/admin/penjualan/so/penjualan/histori">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/history.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                        </div>
					</Row>
                </CardBody>
          </div>
        </Row>
      </Container>
      
    </>
  );
}